import PlanPage from './PlanPage';

export default PlanPage;
